import React from 'react';
import { Button, Select } from 'antd';
import { isOldBrowserMode } from '../utils/voicePreferences';

export function TvInlinePanel({
  title,
  visible,
  onClose,
  children,
  primaryLabel,
  onPrimary,
  variant = 'default',
}) {
  if (!visible) {
    return null;
  }

  return (
    <section className={`tv-inline-panel${variant === 'warning' ? ' tv-inline-panel-warning' : ''}`}>
      <div className="tv-inline-panel-header">
        <h3>{title}</h3>
        {onClose ? (
          <Button size="large" onClick={onClose}>
            Close
          </Button>
        ) : null}
      </div>
      <div className="tv-inline-panel-body">{children}</div>
      {primaryLabel && onPrimary ? (
        <div className="tv-inline-panel-actions">
          <Button block size="large" onClick={onPrimary} className="homepage-go-btn">
            {primaryLabel}
          </Button>
        </div>
      ) : null}
    </section>
  );
}

export function TvOptionButtons({ options, value, onChange, getValue = (option) => option.Id, getLabel = (option) => option.Text }) {
  return (
    <div className="tv-option-list">
      {options.map((option) => {
        const optionValue = getValue(option);
        const selected = value === optionValue;

        return (
          <Button
            key={optionValue}
            block
            size="large"
            className={`homepage-option-btn${selected ? ' homepage-option-btn-selected' : ''}`}
            onClick={() => onChange(optionValue)}
          >
            {getLabel(option)}
          </Button>
        );
      })}
    </div>
  );
}

export function TvSettingsSelect({
  options,
  value,
  onChange,
  placeholder = 'Select',
  getValue = (option) => option.Id,
  getLabel = (option) => option.Text,
}) {
  if (isOldBrowserMode()) {
    return (
      <Select
        className="tv-settings-dropdown"
        size="large"
        placeholder={placeholder}
        value={value ?? undefined}
        onChange={onChange}
        options={options.map((option) => ({
          value: getValue(option),
          label: getLabel(option),
        }))}
      />
    );
  }

  return (
    <TvOptionButtons
      options={options}
      value={value}
      onChange={onChange}
      getValue={getValue}
      getLabel={getLabel}
    />
  );
}

export function TvLogoutPanel({ visible, onCancel, onConfirm }) {
  if (!visible) {
    return null;
  }

  return (
    <section className="tv-inline-panel tv-inline-panel-warning">
      <div className="tv-inline-panel-header">
        <h3>Logout</h3>
        <Button size="large" onClick={onCancel}>
          Close
        </Button>
      </div>
      <p className="tv-inline-panel-text">Are you sure to logout?</p>
      <div className="tv-inline-panel-actions">
        <Button block size="large" onClick={onCancel}>
          No
        </Button>
        <Button block size="large" danger type="primary" onClick={onConfirm}>
          Yes, Logout
        </Button>
      </div>
    </section>
  );
}
